'use strict';

var csjs = require('./csjs');

module.exports = csjs;
module.exports.csjs = csjs;
module.exports.getCss = require('./get-css');



/*****************
 ** WEBPACK FOOTER
 ** ./~/csjs/index.js
 ** module id = 12
 ** module chunks = 0
 **/